import { css, unsafeCSS } from 'lit';
import { sbkCoreBreakpointMd, sbkCoreBreakpointXl } from '@/tokens/variables.js'

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);
const breakpointXl = unsafeCSS(`${sbkCoreBreakpointXl}`);

export const facet1 = css`
    :host {
        --clip-path-facet-1--default: polygon( 99.25% 30.025%,99.25% 75.6%,67.675% 93.825%,67.675% 93.825%,66.18% 94.588%,64.63% 95.181%,63.039% 95.605%,61.42% 95.859%,59.788% 95.944%,58.155% 95.859%,56.536% 95.605%,54.945% 95.181%,53.395% 94.588%,51.9% 93.825%,20.325% 75.6%,20.325% 75.6%,16.802% 73.311%,13.579% 70.692%,10.673% 67.774%,8.101% 64.586%,5.878% 61.156%,4.022% 57.515%,2.55% 53.692%,1.478% 49.717%,0.822% 45.618%,0.6% 41.425%,0.6% 41.425%,0.6% 41.425%,0.822% 37.232%,1.478% 33.133%,2.55% 29.158%,4.022% 25.335%,5.878% 21.694%,8.101% 18.264%,10.673% 15.076%,13.579% 12.158%,16.802% 9.539%,20.325% 7.25%,20.325% 7.25%,20.325% 7.25%,24.065% 5.347%,27.942% 3.866%,31.921% 2.809%,35.97% 2.174%,40.053% 1.963%,44.137% 2.174%,48.188% 2.809%,52.171% 3.866%,56.053% 5.347%,59.8% 7.25%,99.25% 30.025% );
        --clip-path-facet-1--mobile: polygon( 5.194% 0%,5.194% 0%,4.239% 2.4%,3.374% 4.865%,2.602% 7.388%,1.926% 9.966%,1.347% 12.593%,0.868% 15.264%,0.492% 17.975%,0.22% 20.721%,0.055% 23.496%,0% 26.296%,0% 26.296%,0.226% 31.957%,0.891% 37.492%,1.979% 42.862%,3.472% 48.025%,5.354% 52.944%,7.608% 57.579%,10.217% 61.889%,13.163% 65.836%,16.43% 69.38%,20% 72.481%,52% 97.111%,52% 97.111%,53.516% 98.141%,55.088% 98.942%,56.702% 99.514%,58.344% 99.858%,60% 99.972%,61.656% 99.858%,63.298% 99.514%,64.912% 98.942%,66.484% 98.141%,68% 97.111%,100% 72.481%,100% 0%,5.194% 0% );

        --facet-1__clip-path--mobile: var(--_facet-1__clip-path--mobile, var(--clip-path-facet-1--mobile));
        --facet-1__aspect-ratio--mobile: var(--_facet-1__aspect-ratio--mobile, 4 / 3);
        --facet-1__width--mobile: var(--_facet-1__width--mobile, inherit);
        --facet-1__margin--mobile: var(--_facet-1__margin--mobile, 0);

        --facet-1-md__display--md: var(--_facet-1-md__display--md, block);
        --facet-1-lg__display--md: var(--_facet-1-lg__display--md, none);
        --facet-1-md__display--lg: var(--_facet-1-md__display--lg, none);
        --facet-1-lg__display--lg: var(--_facet-1-lg__display--lg, block);

        --facet-1__margin: 0;
        --facet-1__width: 100%;
        --image__facet-1__margin: var(--_image__facet-1__margin, var(--facet-1__margin));
        --image__facet-1__width: var(--_image__facet-1__width, var(--facet-1__width));
        --image__facet-1__margin--xl: var(--_image__facet-1__margin--xl, var(--facet-1__margin));
        --image__facet-1__width--xl: var(--_image__facet-1__width--xl, var(--facet-1__width));

        --facet-1__onDark: var(--_facet-1__onDark, none);
        --facet-1__onDark--xl: var(--_facet-1__onDark--xl, none);
    }

    .image__facet-1 {
        ::slotted(img), ::slotted(picture) {
            object-fit: cover;
            clip-path: var(--clip-path-facet-1--default);
            aspect-ratio: 1;
            width: var(--image__facet-1__width);
            height: auto;
            z-index: 2;
        }
    }

    .image-facet-1-md {
        display: var(--facet-1-md__display--lg);
    }
    .image-facet-1-lg {
        display: var(--facet-1-lg__display--lg);
        position: absolute;
        top: 1.3%;
        left: -19.6%;
        width: 143.8%;
        height: auto;
        z-index: 1;
    }

    .image__facet-1--crop-mobile {
        .image-facet-1-md {
            display: var(--facet-1-md__display--md);
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: auto;
            z-index: 1;
        }
        .image-facet-1-lg {
            display: var(--facet-1-lg__display--md);
        }
        ::slotted(img), ::slotted(picture) {
            clip-path: var(--facet-1__clip-path--mobile);
            aspect-ratio: var(--facet-1__aspect-ratio--mobile);
            width: var(--facet-1__width--mobile);
            margin: var(--facet-1__margin--mobile);
        }
        @media screen and (min-width: ${breakpointMd}) {
            ::slotted(img), ::slotted(picture) {
                clip-path: var(--clip-path-facet-1--default);
                aspect-ratio: 1;
                width: var(--image__facet-1__width);
                margin: var(--image__facet-1__margin);
            }
            .image-facet-1-md {
                display: var(--facet-1-md__display--lg);
            }
            .image-facet-1-lg {
                display: var(--facet-1-lg__display--lg);
                position: absolute;
                top: 1.3%;
                left: -19.6%;
                width: 143.8%;
                height: auto;
                z-index: 1;
            }
        }
    }

    .image-facet-1__onDark {
        display: var(--facet-1__onDark);
        position: absolute;
        top: 2%;
        right: -19%;
        width: 131%;
        height: auto;
        z-index: 3;
    }
    .image-facet-1__onDark--xl {
        display: none;
    }

    @media screen and (min-width: ${breakpointXl}) {
        .image-facet-1__onDark--xl {
            display: var(--facet-1__onDark--xl);
            position: absolute;
            top: 6px;
            right: 2px;
            width: 112%;
            height: auto;
            z-index: 3;
        }
        .image-facet-1__onDark {
            display: none;
        }
        .image__facet-1--alternative .image-facet-1__onDark--xl {
            top: -12.5%;
            right: -22.5%;
            width: 126%;
        }
    }
  }
`;
